import { volumeLoader } from '@cornerstonejs/core';
import { cornerstoneStreamingImageVolumeLoader } from '@cornerstonejs/streaming-image-volume-loader';

const initVolumeLoader = () => {
	volumeLoader.registerUnknownVolumeLoader(cornerstoneStreamingImageVolumeLoader);
	volumeLoader.registerVolumeLoader('cornerstoneStreamingImageVolume', cornerstoneStreamingImageVolumeLoader);
};

export default initVolumeLoader;
